export default __webpack_public_path__ + "2a9adccb1525fc3350c504825adabff6.svg";